import { DatePipe } from '@angular/common';
import { ErrorCode } from '../../shared/models/error-code/error-code';
import { DetailsViewConfiguration } from '../../shared/models/internal/details/details-view-configuration';
import { pascalCaseToWords } from './common-utils';

export function buildErrorCodeDetailsConfiguration(
  item: ErrorCode,
  defaultLanguageSelected: boolean,
  datePipe: DatePipe
): DetailsViewConfiguration {
  return {
    title: item.displayId,
    shortDescription: item.nwNumbersString ?? '',
    translationStateDocumentation: item.translationStateDocumentation,
    translationStateTerminal: item.translationStateTerminal,
    alarmMaskView: {
      sequence: 5,
      alarmMasks: item.alarmMasks ?? [],
      maskTranslationState: item.translationStateTerminal,
    },
    textAreas: [
      {
        sequence: 5,
        label: 'Message',
        value: item.message ?? '-',
        isTranslatable: !defaultLanguageSelected,
      },
      {
        sequence: 20,
        label: 'Cause (Intern)',
        value: item.causeIntern ?? '-',
        isTranslatable: !defaultLanguageSelected,
      },
      {
        sequence: 21,
        label: 'Remedy (Intern)',
        value: item.remedyIntern ?? '-',
        isTranslatable: !defaultLanguageSelected,
      },
      {
        sequence: 18,
        label: 'Cause (Dealer)',
        value: item.causeDealer ?? '-',
        isTranslatable: !defaultLanguageSelected,
      },
      {
        sequence: 19,
        label: 'Remedy (Dealer)',
        value: item.remedyDealer ?? '-',
        isTranslatable: !defaultLanguageSelected,
      },
      {
        sequence: 16,
        label: 'Cause (Farmer)',
        value: item.causeFarmer ?? '-',
        isTranslatable: !defaultLanguageSelected,
      },
      {
        sequence: 17,
        label: 'Remedy (Farmer)',
        value: item.remedyFarmer ?? '-',
        isTranslatable: !defaultLanguageSelected,
      },
    ],
    singleLineDetails: [
      {
        sequence: 2,
        attributes: [{ label: 'Machine Types', value: item.machineType ?? '-' }],
      },
      {
        sequence: 3,
        attributes: [{ label: 'Category', value: (item.categories ?? []).map(pascalCaseToWords).join(', ') }],
      },
      {
        sequence: 4,
        attributes: [
          { label: 'Needs Review', value: (item.needsReview ?? false) ? 'Yes' : 'No' },
          { label: 'Fitness Exclude', value: (item.fitnessExclude ?? false) ? 'Yes' : 'No' },
          { label: 'Aggregate Message', value: (item.aggregateMessage ?? false) ? 'Yes' : 'No' },
        ],
      },
      {
        sequence: 1,
        attributes: [
          {
            label: 'First NwNumber Version:',
            value: item.startingWithVersion || '-',
          },
          {
            label: 'Last NwNumber Version:',
            value: item.endingWithVersion || '-',
          },
        ],
      },
      {
        sequence: 13,
        attributes: [
          {
            label: 'AS Review at:',
            value: datePipe.transform(item.reviewedByAfterSalesAt, 'dd.MM.yyyy HH:mm') || '-',
          },
          {
            label: 'TO Review at:',
            value: datePipe.transform(item.reviewedByTechnicalOrganisationAt, 'dd.MM.yyyy HH:mm') || '-',
          },
        ],
      },
    ],
    separators: [12],
    displayLinkedDtcs: false,
    internalNotes: item.internalNotes,
  };
}
